var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCalendarGlyph(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 19.5C11 18.6716 11.6716 18 12.5 18H23.5C24.3284 18 25 18.6716 25 19.5C25 20.3284 24.3284 21 23.5 21H12.5C11.6716 21 11 20.3284 11 19.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 23C11.6716 23 11 23.6716 11 24.5C11 25.3284 11.6716 26 12.5 26H18.5C19.3284 26 20 25.3284 20 24.5C20 23.6716 19.3284 23 18.5 23H12.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 5.875C14.6213 5.875 15.125 6.37868 15.125 7V8.875H24.875V7C24.875 6.37868 25.3787 5.875 26 5.875C26.6213 5.875 27.125 6.37868 27.125 7V8.875H30.25C32.3901 8.875 34.125 10.6099 34.125 12.75V29.25C34.125 31.3901 32.3901 33.125 30.25 33.125H9.75C7.6099 33.125 5.875 31.3901 5.875 29.25V12.75C5.875 10.6099 7.6099 8.875 9.75 8.875H12.875V7C12.875 6.37868 13.3787 5.875 14 5.875ZM8.125 29V17C8.125 15.9645 8.96447 15.125 10 15.125H30C31.0355 15.125 31.875 15.9645 31.875 17V29C31.875 30.0355 31.0355 30.875 30 30.875H10C8.96447 30.875 8.125 30.0355 8.125 29Z",
    fill: "white"
  })));
}

export default SvgCalendarGlyph;